"use strict";

var _classCallCheck = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = exports.array = exports.rustEnum = exports.str = exports.vecU8 = exports.tagged = exports.vec = exports.bool = exports.option = exports.publicKey = exports.i128 = exports.u128 = exports.i64 = exports.u64 = exports.struct = exports.f64 = exports.f32 = exports.i32 = exports.u32 = exports.i16 = exports.u16 = exports.i8 = exports.u8 = void 0;

var buffer_layout_1 = require("buffer-layout");

var web3_js_1 = require("@solana/web3.js");

var bn_js_1 = __importDefault(require("bn.js"));

var buffer_layout_2 = require("buffer-layout");

Object.defineProperty(exports, "u8", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.u8;
  }
});
Object.defineProperty(exports, "i8", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.s8;
  }
});
Object.defineProperty(exports, "u16", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.u16;
  }
});
Object.defineProperty(exports, "i16", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.s16;
  }
});
Object.defineProperty(exports, "u32", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.u32;
  }
});
Object.defineProperty(exports, "i32", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.s32;
  }
});
Object.defineProperty(exports, "f32", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.f32;
  }
});
Object.defineProperty(exports, "f64", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.f64;
  }
});
Object.defineProperty(exports, "struct", {
  enumerable: true,
  get: function get() {
    return buffer_layout_2.struct;
  }
});

var BNLayout = /*#__PURE__*/function (_buffer_layout_1$Layo) {
  _inherits(BNLayout, _buffer_layout_1$Layo);

  var _super = _createSuper(BNLayout);

  function BNLayout(span, signed, property) {
    var _this;

    _classCallCheck(this, BNLayout);

    _this = _super.call(this, span, property);
    _this.blob = buffer_layout_1.blob(span);
    _this.signed = signed;
    return _this;
  }

  _createClass(BNLayout, [{
    key: "decode",
    value: function decode(b) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var num = new bn_js_1.default(this.blob.decode(b, offset), 10, 'le');

      if (this.signed) {
        return num.fromTwos(this.span * 8).clone();
      }

      return num;
    }
  }, {
    key: "encode",
    value: function encode(src, b) {
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (this.signed) {
        src = src.toTwos(this.span * 8);
      }

      return this.blob.encode(src.toArrayLike(Buffer, 'le', this.span), b, offset);
    }
  }]);

  return BNLayout;
}(buffer_layout_1.Layout);

function u64(property) {
  return new BNLayout(8, false, property);
}

exports.u64 = u64;

function i64(property) {
  return new BNLayout(8, true, property);
}

exports.i64 = i64;

function u128(property) {
  return new BNLayout(16, false, property);
}

exports.u128 = u128;

function i128(property) {
  return new BNLayout(16, true, property);
}

exports.i128 = i128;

var WrappedLayout = /*#__PURE__*/function (_buffer_layout_1$Layo2) {
  _inherits(WrappedLayout, _buffer_layout_1$Layo2);

  var _super2 = _createSuper(WrappedLayout);

  function WrappedLayout(layout, decoder, encoder, property) {
    var _this2;

    _classCallCheck(this, WrappedLayout);

    _this2 = _super2.call(this, layout.span, property);
    _this2.layout = layout;
    _this2.decoder = decoder;
    _this2.encoder = encoder;
    return _this2;
  }

  _createClass(WrappedLayout, [{
    key: "decode",
    value: function decode(b, offset) {
      return this.decoder(this.layout.decode(b, offset));
    }
  }, {
    key: "encode",
    value: function encode(src, b, offset) {
      return this.layout.encode(this.encoder(src), b, offset);
    }
  }, {
    key: "getSpan",
    value: function getSpan(b, offset) {
      return this.layout.getSpan(b, offset);
    }
  }]);

  return WrappedLayout;
}(buffer_layout_1.Layout);

function publicKey(property) {
  return new WrappedLayout(buffer_layout_1.blob(32), function (b) {
    return new web3_js_1.PublicKey(b);
  }, function (key) {
    return key.toBuffer();
  }, property);
}

exports.publicKey = publicKey;

var OptionLayout = /*#__PURE__*/function (_buffer_layout_1$Layo3) {
  _inherits(OptionLayout, _buffer_layout_1$Layo3);

  var _super3 = _createSuper(OptionLayout);

  function OptionLayout(layout, property) {
    var _this3;

    _classCallCheck(this, OptionLayout);

    _this3 = _super3.call(this, -1, property);
    _this3.layout = layout;
    _this3.discriminator = buffer_layout_1.u8();
    return _this3;
  }

  _createClass(OptionLayout, [{
    key: "encode",
    value: function encode(src, b) {
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (src === null || src === undefined) {
        return this.discriminator.encode(0, b, offset);
      }

      this.discriminator.encode(1, b, offset);
      return this.layout.encode(src, b, offset + 1) + 1;
    }
  }, {
    key: "decode",
    value: function decode(b) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var discriminator = this.discriminator.decode(b, offset);

      if (discriminator === 0) {
        return null;
      } else if (discriminator === 1) {
        return this.layout.decode(b, offset + 1);
      }

      throw new Error('Invalid option ' + this.property);
    }
  }, {
    key: "getSpan",
    value: function getSpan(b) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var discriminator = this.discriminator.decode(b, offset);

      if (discriminator === 0) {
        return 1;
      } else if (discriminator === 1) {
        return this.layout.getSpan(b, offset + 1) + 1;
      }

      throw new Error('Invalid option ' + this.property);
    }
  }]);

  return OptionLayout;
}(buffer_layout_1.Layout);

function option(layout, property) {
  return new OptionLayout(layout, property);
}

exports.option = option;

function bool(property) {
  return new WrappedLayout(buffer_layout_1.u8(), decodeBool, encodeBool, property);
}

exports.bool = bool;

function decodeBool(value) {
  if (value === 0) {
    return false;
  } else if (value === 1) {
    return true;
  }

  throw new Error('Invalid bool: ' + value);
}

function encodeBool(value) {
  return value ? 1 : 0;
}

function vec(elementLayout, property) {
  var length = buffer_layout_1.u32('length');
  var layout = buffer_layout_1.struct([length, buffer_layout_1.seq(elementLayout, buffer_layout_1.offset(length, -length.span), 'values')]);
  return new WrappedLayout(layout, function (_ref) {
    var values = _ref.values;
    return values;
  }, function (values) {
    return {
      values: values
    };
  }, property);
}

exports.vec = vec;

function tagged(tag, layout, property) {
  var wrappedLayout = buffer_layout_1.struct([u64('tag'), layout.replicate('data')]);

  function decodeTag(_ref2) {
    var receivedTag = _ref2.tag,
        data = _ref2.data;

    if (!receivedTag.eq(tag)) {
      throw new Error('Invalid tag, expected: ' + tag.toString('hex') + ', got: ' + receivedTag.toString('hex'));
    }

    return data;
  }

  return new WrappedLayout(wrappedLayout, decodeTag, function (data) {
    return {
      tag: tag,
      data: data
    };
  }, property);
}

exports.tagged = tagged;

function vecU8(property) {
  var length = buffer_layout_1.u32('length');
  var layout = buffer_layout_1.struct([length, buffer_layout_1.blob(buffer_layout_1.offset(length, -length.span), 'data')]);
  return new WrappedLayout(layout, function (_ref3) {
    var data = _ref3.data;
    return data;
  }, function (data) {
    return {
      data: data
    };
  }, property);
}

exports.vecU8 = vecU8;

function str(property) {
  return new WrappedLayout(vecU8(), function (data) {
    return data.toString('utf-8');
  }, function (s) {
    return Buffer.from(s, 'utf-8');
  }, property);
}

exports.str = str;

function rustEnum(variants, property, discriminant) {
  var unionLayout = buffer_layout_1.union(discriminant !== null && discriminant !== void 0 ? discriminant : buffer_layout_1.u8(), property);
  variants.forEach(function (variant, index) {
    return unionLayout.addVariant(index, variant, variant.property);
  });
  return unionLayout;
}

exports.rustEnum = rustEnum;

function array(elementLayout, length, property) {
  var layout = buffer_layout_1.struct([buffer_layout_1.seq(elementLayout, length, 'values')]);
  return new WrappedLayout(layout, function (_ref4) {
    var values = _ref4.values;
    return values;
  }, function (values) {
    return {
      values: values
    };
  }, property);
}

exports.array = array;

var MapEntryLayout = /*#__PURE__*/function (_buffer_layout_1$Layo4) {
  _inherits(MapEntryLayout, _buffer_layout_1$Layo4);

  var _super4 = _createSuper(MapEntryLayout);

  function MapEntryLayout(keyLayout, valueLayout, property) {
    var _this4;

    _classCallCheck(this, MapEntryLayout);

    _this4 = _super4.call(this, keyLayout.span + valueLayout.span, property);
    _this4.keyLayout = keyLayout;
    _this4.valueLayout = valueLayout;
    return _this4;
  }

  _createClass(MapEntryLayout, [{
    key: "decode",
    value: function decode(b, offset) {
      offset = offset || 0;
      var key = this.keyLayout.decode(b, offset);
      var value = this.valueLayout.decode(b, offset + this.keyLayout.getSpan(b, offset));
      return [key, value];
    }
  }, {
    key: "encode",
    value: function encode(src, b, offset) {
      offset = offset || 0;
      var keyBytes = this.keyLayout.encode(src[0], b, offset);
      var valueBytes = this.valueLayout.encode(src[1], b, offset + keyBytes);
      return keyBytes + valueBytes;
    }
  }, {
    key: "getSpan",
    value: function getSpan(b, offset) {
      return this.keyLayout.getSpan(b, offset) + this.valueLayout.getSpan(b, offset);
    }
  }]);

  return MapEntryLayout;
}(buffer_layout_1.Layout);

function map(keyLayout, valueLayout, property) {
  var length = buffer_layout_1.u32('length');
  var layout = buffer_layout_1.struct([length, buffer_layout_1.seq(new MapEntryLayout(keyLayout, valueLayout), buffer_layout_1.offset(length, -length.span), 'values')]);
  return new WrappedLayout(layout, function (_ref5) {
    var values = _ref5.values;
    return new Map(values);
  }, function (values) {
    return {
      values: Array.from(values.entries())
    };
  }, property);
}

exports.map = map;